/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ index: NonNullable<unknown>, total: NonNullable<unknown> }} Box_Label_Package_IndexInputs */

const vi_box_label_package_index = /** @type {(inputs: Box_Label_Package_IndexInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Kiện ${i?.index}/${i?.total}`)
};

/**

* @param {Box_Label_Package_IndexInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const box_label_package_index = /** @type {((inputs: Box_Label_Package_IndexInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Box_Label_Package_IndexInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_box_label_package_index(inputs)
});